<div id="contentProgressBar" class="containet" *ngIf="level">
  <h2 id="hrfBarPass" positionV="bottom" arrow>{{level.label}}</h2>
  <div id="brogressBarOut" class="out">
    <div d="brogressBarLevel" [ngClass]="level.level"></div>
  </div>
</div>